import { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";
import { Download, Trash2, FolderOpen } from "lucide-react";

const LS_KEY = "omni-downloads";
function load() { try { return JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch { return []; } }
function save(list) { localStorage.setItem(LS_KEY, JSON.stringify(list)); }

export function recordDownload(name, url, size) {
  try {
    const list = load();
    list.unshift({ id: Date.now().toString(), name, url, size, date: new Date().toISOString() });
    save(list.slice(0, 100));
  } catch {}
}

export default function DownloadsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { setItems(load()); }, []);
  const clearAll = () => { save([]); setItems([]); };
  const remove = (id) => { const n = items.filter((x) => x.id !== id); setItems(n); save(n); };

  const sample = () => {
    const html = `<!doctype html><title>OmniSearch Page</title><body><h1>Hello from OmniSearch</h1>`;
    const blob = new Blob([html], { type: "text/html" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "omnisearch-sample.html";
    a.click();
    recordDownload("omnisearch-sample.html", a.href, blob.size);
    setItems(load());
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 py-12" data-testid="downloads-page">
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight flex items-center gap-3">
            <Download size={28} /> Téléchargements
          </h1>
          <div className="flex gap-2">
            <Button onClick={sample} variant="outline" className="rounded-full" data-testid="dl-sample-btn">Tester</Button>
            {items.length > 0 && (
              <Button onClick={clearAll} variant="outline" className="text-red-600 rounded-full" data-testid="dl-clear-btn">
                <Trash2 size={15} className="mr-1" /> Effacer
              </Button>
            )}
          </div>
        </div>
        <p className="text-sm text-gray-500 mb-6">Vos fichiers récents téléchargés via OmniSearch (sauvegardés dans votre navigateur).</p>

        {items.length === 0 ? (
          <div className="border border-dashed border-[var(--omni-border)] rounded-lg p-12 text-center text-gray-500">
            <FolderOpen className="inline mb-3" /><br />
            Aucun téléchargement.
          </div>
        ) : (
          <div className="border border-[var(--omni-border)] rounded-lg divide-y divide-[var(--omni-border)]">
            {items.map((d) => (
              <div key={d.id} className="px-4 py-3 flex items-center gap-3 hover:bg-[var(--omni-surface)]" data-testid={`dl-item-${d.id}`}>
                <FolderOpen size={18} className="text-gray-400" />
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate">{d.name}</div>
                  <div className="text-xs text-gray-500">{new Date(d.date).toLocaleString()} · {(d.size / 1024).toFixed(1)} Ko</div>
                </div>
                <button onClick={() => remove(d.id)} className="p-2 rounded-md hover:bg-gray-100 text-red-600" data-testid={`dl-delete-${d.id}`}>
                  <Trash2 size={15} />
                </button>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
